import GlobalStyles from '@mui/material/GlobalStyles'
import React from 'react'
import ralewayBlack from '../PDFrender/Raleway-Black.ttf'
import ralewayBold from '../PDFrender/Raleway-Bold.ttf'
import ralewayRegular from '../PDFrender/Raleway-Regular.ttf'

/**
 * Font family of the print preview. It uses the same Raleway files as the PDF and DOCX exports.
 * The app's own Raleway only has the black weight, which would make all preview text look bold.
 */
export const printFontFamily = 'CaleoPrintRaleway'

const fontFaces = [
  { src: ralewayRegular, weight: 400 },
  { src: ralewayBold, weight: 700 },
  { src: ralewayBlack, weight: 900 },
].map(({ src, weight }) => ({
  '@font-face': {
    fontFamily: printFontFamily,
    fontStyle: 'normal',
    fontWeight: weight,
    fontDisplay: 'swap',
    src: `url(${src}) format("truetype")`,
  },
}))

/**
 * Registers the print preview font faces.
 *
 * @returns {JSX.Element} The global font face styles.
 */
const PrintFontFaces: React.FC = () => <GlobalStyles styles={fontFaces} />

export default PrintFontFaces
